import { mapState, mapActions } from 'vuex';
import Swal from 'sweetalert2';

export const QuestionMixin = {
  name: 'QuestionMixin',

  components: {
    Question: () => import('@/components/Question/Question.vue'),
  },

  data: () => {
    return {
      currentQuestion: {},
      questionCourseId: -1,
      isShowQuestion: false,
    };
  },

  computed: {
    ...mapState('Mixins/Question', {
      ms_question: 'question',
    }),
  },

  methods: {
    ...mapActions('Mixins/Question', {
      ma_getQuestion: 'getQuestion',
      ma_updateQuestionHtml: 'updateQuestionHtml',
      ma_answer: 'answer',
      ma_setQuestion: 'setQuestion',
      markQuestion: 'markQuestion',
    }),

    getQuestionCourseId(payload) {
      this.questionCourseId = payload.courseId;
    },

    async openQuestion(payload) {
      this.getQuestionCourseId(payload);
      await this.ma_getQuestion({
        courseId: this.questionCourseId,
        questionId: payload.groupId ? payload.groupId : payload.questionId,
        subQuestionId: payload.groupId ? payload.questionId : null,
      });
      this.isShowQuestion = true;
    },

    async updateQuestionHtml() {
      await this.ma_updateQuestionHtml({
        courseId: this.questionCourseId,
        questionId: this.ms_question.questionId,
      });
    },

    setQuestion(payload) {
      this.ma_setQuestion(payload);
    },

    doAnswer(payload) {
      this.ma_answer({
        ...payload,
        courseId: this.questionCourseId,
      });
    },

    async mark() {
      await this.markQuestion({
        courseId: this.questionCourseId,
      });
      if (this.ms_question.qType !== 'xl') {
        Swal.fire({
          backdrop: false,
          icon: 'success',
          width: '400px',
          title: `${this.ms_question.isMarked ? '收藏成功' : '已取消收藏'}`,
          showConfirmButton: false,
          timer: 800,
        });
      } else {
        Swal.fire({
          backdrop: false,
          icon: 'success',
          width: '400px',
          title: `${this.ms_question.subQuestions[this.ms_question.pos].isMarked ? '收藏成功' : '已取消收藏'
            }`,
          showConfirmButton: false,
          timer: 800,
        });
      }
    },

    closeQuestion() {
      this.isShowQuestion = false;
    },
  },
};

export default QuestionMixin;
